module.exports = __webpack_public_path__ + "media/images/vp/icon.yt.red-38e6b6e472aef1bdcc4291e03054f401.png";